var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("overview.emails.draft.header")))]),_c('vca-row',[_c('div',{staticClass:"clickable",on:{"click":function($event){return _vm.navDraft('requested')}}},[_vm._v(" "+_vm._s(_vm.$t("overview.emails.draft.total"))+" ")]),_c('div',{staticClass:"bold"},[_vm._v(_vm._s(_vm.emailCount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }